import React from "react";
import "./Gamemode.css";

const ModeButton = ({ mode, isActive, onClick }) => {
  return (
    <li>
      <button
        type="button"
        className={`button-block-mode ${isActive ? "active" : ""}`}
        data-bs-toggle="button"
        autoComplete="off"
        onClick={onClick}
        value={mode}
      >
        {mode}x{mode}
      </button>
    </li>
  );
};

export default React.memo(ModeButton);
